<a [routerLink]="path" [ngClass]="{'fw-bold': unread}">
  {{data}}
</a>
